<template>
    <div class="gap-2 flex">
        <Select
            :model-value="selectedEventType || 'all'"
            @update:model-value="showByEventType"
        >
            <SelectTrigger>
                <SelectValue
                    class="px-2"
                    :placeholder="$t('team_reports.reservations_by_event')"
                />
            </SelectTrigger>
            <SelectContent>
                <SelectGroup>
                    <SelectItem class="gap-3 px-4" value="all">
                        {{ $t("team_reports.all_events") }}
                    </SelectItem>

                    <SelectItem
                        v-for="eventType of eventTypes"
                        :key="eventType.id"
                        class="gap-3 px-4"
                        :value="eventType.id.toString()"
                    >
                        {{ eventType.name }}
                    </SelectItem>
                </SelectGroup>
            </SelectContent>
        </Select>
    </div>
</template>

<script setup lang="ts">
import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";

import { EventType } from "../../EventTypes/types/EventType";

defineProps<{
    eventTypes: EventType[];
    teamId: number;
    selectedEventType?: string;
}>();

const emit = defineEmits(["update:selectedEventType"]);

const showByEventType = (eventTypeId: string) => {
    if (eventTypeId === "all") {
        clearFilter();
        return;
    }
    emit("update:selectedEventType", eventTypeId);
};

function clearFilter() {
    emit("update:selectedEventType", undefined);
}
</script>
